import { Controller, useFormContext } from "react-hook-form";

import { NcTextArea, NcTextAreaProps } from "./nc-text-area";

export interface NcFormTextAreaProps extends Omit<
  NcTextAreaProps,
  "name" | "validate" | "onBlur" | "value" | "validationBehavior"
> {
  name: string; // Was optional in NcTextAreaProps and is now required
}

export const NcFormTextArea = ({ name, onChange, ...props }: NcFormTextAreaProps) => {
  const { control } = useFormContext();
  return (
    <Controller
      control={control}
      name={name}
      render={({
        field: { name, value, onChange: formOnChange, onBlur, ref },
        fieldState: { invalid, error },
      }) => (
        <NcTextArea
          name={name}
          value={value}
          onChange={value => {
            onChange?.(value);
            formOnChange(value);
          }}
          onBlur={onBlur}
          validationBehavior="aria"
          isInvalid={invalid}
          error={error}
          ref={ref}
          {...props}
        />
      )}
    />
  );
};
